import React from 'react';
import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="zoho-cta">
      <div className="zoho-cta-container">

        <div className="zoho-cta-content">
          <div className="zoho-cta-text">
            <h2 className="zoho-cta-title">
              Ready to Transform Your Business?
            </h2>
            <p className="zoho-cta-subtitle">
              Let’s build your digital future together. Contact us today for a free consultation.
            </p>
          </div>

          <div className="zoho-cta-action">
            <Link to="/contact" className="zoho-btn zoho-btn-primary">
              Get In Touch
            </Link>
          </div>
        </div>

      </div>
    </section>
  );
};

export default CTASection;
